import React from 'react';
import Video from './Video';
import ProfileImage from '../Common/ProfileImage'
import { CALL_STATUS_CONNECTED, CALL_STATUS_HOLD } from '../../Helpers/Call/Constant';
import { AudioOffHoc, DropdownArrowHoc, IconPinActiveHoc, VideoOffHoc } from '../../assets/images';
import { initialNameHandle } from '../../Helpers/Chat/User';
import { handleAudioClasses } from '../../Helpers/Call/Call';
import {getFromLocalStorageAndDecrypt} from '../../Helpers/Chat/webChatEncryptDecrypt';

const BigVideo = (props) => {

    const { 
        audioMuted, videoMuted=true, rosterData, stream, volumeLevel, showVoiceDetect, inverse
    } = props
    const token = getFromLocalStorageAndDecrypt('token');
    const initial = initialNameHandle(rosterData);
    const indicator = false;
return(
    <>
    {!videoMuted && props.callStatus && (props.callStatus.toLowerCase() === CALL_STATUS_CONNECTED || props.callStatus.toLowerCase() === CALL_STATUS_HOLD) && stream && stream.video &&
        <div className="VideoWrapper">
            <div className="VideoWrapperInner">
            <div className="participantCallStatus video">
            {(props.setPinUser && props.jid === props.pinUserJid) &&
                <i className="pinned"><IconPinActiveHoc viewBox="0 0 5.713 10.628"/></i>
                }
        <>
            {audioMuted &&
            <i title="Participant is muted" className="AudioOffRemote"><AudioOffHoc viewBox="0 0 19.144 20.207" /></i>
        }
            {indicator && 
                   <div className={`audio_indication left height_adjust transistion_adjust ${handleAudioClasses(60)}`}>
                    <div className="audio_indicator audio_indicator_1"></div>
                    <div className="audio_indicator audio_indicator_2"></div>
                    <div className="audio_indicator audio_indicator_3"></div>
                </div>
            }
        </>                        
            </div>
                <Video stream={stream.video} muted={false} id={stream.video.id} inverse={inverse}/>
              
            <div onClick={props.handleVideoFullView} className="VideofullView">
                <i><DropdownArrowHoc viewBox='0 0 14 14'/> </i>
            </div>
            </div>
            <span className="ParticipantInfo lg">{rosterData.displayName || rosterData.nickName}</span>
        </div>
    }
    {(videoMuted || !stream || !stream.video || (props.callStatus && (props.callStatus.toLowerCase() !== CALL_STATUS_CONNECTED && props.callStatus.toLowerCase() !== CALL_STATUS_HOLD))) &&
        <div className="avatar-wrapper">
        <div className="participantCallStatus audio">
            {videoMuted && <i title="Participant has stopped the camera" className="videoOffRemote"><VideoOffHoc viewBox='0 0 14 14' /></i>}
            {audioMuted &&
                <i title="Participant is muted" className="AudioOffRemote"><AudioOffHoc viewBox="0 0 19.144 20.207" /></i>
            }
             {indicator &&
                   <div className={`audio_indication left height_adjust transistion_adjust ${handleAudioClasses(60)}`}>
                    <div className="audio_indicator audio_indicator_1"></div>
                    <div className="audio_indicator audio_indicator_2"></div>
                    <div className="audio_indicator audio_indicator_3"></div>
                </div>
            }
            {(props.setPinUser && props.jid === props.pinUserJid) &&
                <i className="pinned"><IconPinActiveHoc viewBox="0 0 5.713 10.628" /></i>
            }
        </div>
        <div className="avatar" id="dominantSpeakerAvatar">
             <div className={"avatar-info " + (showVoiceDetect ? " v-detect" : "")}>
                 <span style={{ "transform": "scale(" + volumeLevel + ")"}} className="voice"></span>
                <ProfileImage
                    name = {initial}
                    chatType='chat'
                    userToken={token}
                    temporary={false}
                    imageToken={rosterData.thumbImage !== "" ? rosterData.thumbImage : rosterData.image}
                />
            </div>
        </div>
        <div onClick={props.handleVideoFullView} className="VideofullView">
                <i><DropdownArrowHoc viewBox='0 0 14 14'/> </i>
            </div>
            <span className="ParticipantInfo lg">{rosterData.displayName || rosterData.nickName}</span>
        </div>
    }
</>
)}
export default BigVideo;